import { FC } from "react";

const ArrowRight: FC<{ className?: string }> = ({ className }) => {
    return (
        <svg className={className} width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.583 0.155824C15.7844 -0.0519403 16.1072 -0.0519421 16.3086 0.155824L23.1318 7.19586L23.1543 7.21149C23.1878 7.23544 23.219 7.26327 23.2471 7.2945C23.3407 7.39878 23.3998 7.54033 23.4004 7.69782V7.70172C23.3998 7.85928 23.3408 8.00072 23.2471 8.10504C23.219 8.13626 23.1878 8.1641 23.1543 8.18805L23.1318 8.20368L16.3086 15.2437C16.1072 15.4515 15.7844 15.4515 15.583 15.2437C15.3768 15.0307 15.3767 14.6813 15.583 14.4683L21.5732 8.28864H0.557617C0.260143 8.28864 6.48371e-05 8.03532 0 7.69977C0 7.36416 0.260106 7.1109 0.557617 7.1109H21.5732L15.583 0.930238C15.3771 0.717312 15.3771 0.36874 15.583 0.155824Z" fill="white" />
        </svg>

    )
}

export default ArrowRight;import { FC } from "react";

const ArrowRight: FC<{ className?: string }> = ({ className }) => {
    return (
        <svg className={className} width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.583 0.155824C15.7844 -0.0519403 16.1072 -0.0519421 16.3086 0.155824L23.1318 7.19586L23.1543 7.21149C23.1878 7.23544 23.219 7.26327 23.2471 7.2945C23.3407 7.39878 23.3998 7.54033 23.4004 7.69782V7.70172C23.3998 7.85928 23.3408 8.00072 23.2471 8.10504C23.219 8.13626 23.1878 8.1641 23.1543 8.18805L23.1318 8.20368L16.3086 15.2437C16.1072 15.4515 15.7844 15.4515 15.583 15.2437C15.3768 15.0307 15.3767 14.6813 15.583 14.4683L21.5732 8.28864H0.557617C0.260143 8.28864 6.48371e-05 8.03532 0 7.69977C0 7.36416 0.260106 7.1109 0.557617 7.1109H21.5732L15.583 0.930238C15.3771 0.717312 15.3771 0.36874 15.583 0.155824Z" fill="white" />
        </svg>

    )
}

export default ArrowRight;